import { ref, watch, computed } from '@vue/composition-api';
import store from '@/store';
import { formatDateBr, formatDateNotTime } from '@core/utils/filter';
import SisDkpClienteTokensService from '@/services/sis-dkp-clientes-token.service';
import SisDkpClienteService from '@/services/sis-dkp-clientes.service';
// Notification
import { useToast } from 'vue-toastification/composition';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';

export default function useUsersList(nameModule) {
  // Use toast
  const toast = useToast();
  const service = new SisDkpClienteTokensService();
  const serviceCliente = new SisDkpClienteService();
  const refDataTableClienteToken = ref(null);

  // Table Handlers
  const tableColumns = [
    { key: 'cliente', label: 'Razão Social / Nome Fantasia', sortable: true },
    {
      key: 'data_validade', label: 'Data Validade', sortable: true, formatter: (value) => formatDateNotTime(value),
    },
    {
      key: 'updated_at', label: 'Data Alteração', sortable: true, formatter: (value) => formatDateBr(value),
    },
    { key: 'actions', label: 'Ações', sortable: false },
  ];
  const perPage = ref(10);
  const totalDataTablet = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref('');
  const sortBy = ref('id');
  const isSortDirDesc = ref(true);
  const roleFilter = ref(null);
  const planFilter = ref(null);
  const overlay = ref(true);
  const statusFilter = ref(null);

  const dataMeta = computed(() => {
    const localItemsCount = refDataTableClienteToken.value ? refDataTableClienteToken.value.localItems.length : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalDataTablet.value,
    };
  });

  const refetchData = () => {
    refDataTableClienteToken.value.refresh();
  };

  watch([currentPage, perPage, searchQuery, roleFilter, planFilter, statusFilter], () => {
    console.log('searchQuery', searchQuery.value);
    refetchData();
  });

  const pagination = computed({
    get() {
      return store.getters['sisDkpCLientesTokens/GET_FILTERS'];
    },
    set(value) {
      store.commit('sisDkpCLientesTokens/SET_FILTERS', value);
    },
  });
  const fetchDataTablet = async (ctx, callback) => {
    overlay.value = true;
    store
      .dispatch('sisDkpClientesTokens/findAll', {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
      })
      .then(async (response) => {
        await serviceCliente.findAll();
        const { data, ...pgn } = response;
        callback(data);

        overlay.value = false;
        perPage.value = pgn.paginations.perPage;
        currentPage.value = pgn.paginations.page;
        totalDataTablet.value = pgn.paginations.total;
        store.commit(
          'sisDkpClientesTokens/SET_OPTIONS_CLIENTES',
          store.getters['sisDkpClientes/GET_DKP_CLIENTES_ALL'],
        );
      })
      .catch((error) => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error ao carregar dados',
            text: error.message,
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        });
      });
  };

  const createOrUpdated = (data = store.getters['sisDkpClientesTokens/GET_DKP_CLIENTE_TOKEN']) => new Promise((resolve, reject) => {
    if (data.id !== null) {
      service.edit(data.id, data).then(() => {
        refetchData();
        resolve(true);
      }).catch((error) => {
        reject(error);
      });
    } else {
      service.create(data).then(() => {
        refetchData();
        resolve(true);
      }).catch((error) => {
        reject(error);
      });
    }
  });
  const dataDeletedById = (id) => new Promise((resolve, reject) => {
    service.delete(id).then(() => {
      resolve(true);
    }).catch((error) => {
      reject(error);
    });
  });

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*

  const resolveUserRoleVariant = (role) => {
    if (role === 'subscriber') return 'primary';
    if (role === 'author') return 'warning';
    if (role === 'maintainer') return 'success';
    if (role === 'editor') return 'info';
    if (role === 'admin') return 'danger';
    return 'primary';
  };

  const resolveUserRoleIcon = (role) => {
    if (role === 'subscriber') return 'UserIcon';
    if (role === 'author') return 'SettingsIcon';
    if (role === 'maintainer') return 'DatabaseIcon';
    if (role === 'editor') return 'Edit2Icon';
    if (role === 'admin') return 'ServerIcon';
    return 'UserIcon';
  };

  const resolveUserStatusVariant = (status) => {
    if (status === 'pending') return 'warning';
    if (status === 'active') return 'success';
    if (status === 'inactive') return 'secondary';
    return 'primary';
  };

  return {
    fetchDataTablet,
    tableColumns,
    perPage,
    currentPage,
    totalDataTablet,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refDataTableClienteToken,
    overlay,
    resolveUserRoleVariant,
    resolveUserRoleIcon,
    resolveUserStatusVariant,
    refetchData,

    // Extra Filters
    roleFilter,
    planFilter,
    statusFilter,
    dataDeletedById,
    createOrUpdated,
  };
}
